import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "CategoriaViaticoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "CategoriaViaticoPage",
            ss: ss,
            auth: {},

            ajax: {
                "url": ss.indexCategoriaViatico(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'CategoriaViatico', name: 'CategoriaViatico', title: 'Categoria Viático' },
                { data: 'Tipo', name: 'Tipo', title: 'Tipo Viático' },
                { data: 'MontoViatico', name: 'MontoViatico', title: 'Monto Viático' },
                { data: 'Factor', name: 'Factor', title: 'Factor' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            rols: [],
            categoriaviaticos: [],
            isLoading: false,
            isLoadingFile: false,
            errorBag: {},
            categoriaviatico: {},
            
        };
    },
    methods: {
                
        newCategoriaViatico() {
            this.categoriaviatico = {};
            this.$refs['frm-categoriaviatico'].show();
            // console.log("hhhhola")
        },
        showCategoriaViatico(id) {
            this.isLoading=true;
            this.ss.showCategoriaViatico(id).then(
                (result) => {
                    let response = result.data;
                    this.categoriaviatico = response.data;
                    this.$refs['view-categoriaviatico'].show();
                    this.isLoading=false;
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editCategoriaViatico() {
            this.$refs['frm-categoriaviatico'].show();
            this.$refs['view-categoriaviatico'].hide();
        },
        cancelCategoriaViatico() {
            if (this.categoriaviatico.id) {
                this.$refs['view-categoriaviatico'].show();
            }
            this.$refs['frm-categoriaviatico'].hide();
        },
        saveCategoriaViatico() {
            this.ss.storeCategoriaViatico(this.categoriaviatico).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-categoriaviatico'].hide();
                    this.$refs['datatable-categoriaviatico'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    console.log(error.response.data);
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteCategoriaViatico() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyCategoriaViatico(this.categoriaviatico)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-categoriaviatico'].hide();
                                this.$refs['datatable-categoriaviatico'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        cambiopassword() {
            this.$refs['view-categoriaviatico'].hide();
            this.$refs['view-password'].show();
        },
        cancelPassword() {
            this.$refs['view-password'].hide();
            this.$refs['view-categoriaviatico'].show();
        },
        changePassword() {
            this.password.CategoriaViatico = this.categoriaviatico.id;
            this.ss.changePassword(this.password)
                .then( result => {
                    let response = result.data;
                    if ( response.success ) {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Correcto',
                                variant: 'success',
                                autoHideDelay: 5000
                            }
                        )
                        this.$refs['view-password'].hide();
                        this.$refs['view-categoriaviatico'].show();
                    } else {
                        this.$bvToast.toast(
                            response.msg,
                            {
                                title: 'Oops',
                                variant: 'danger',
                                autoHideDelay: 5000
                            }
                        )
                    }
                })
                .catch( error => {
                    console.log( error );
                    this.$bvToast.toast(
                        'Error al guardar el registro',
                        {
                            title: 'Oops',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                    this.errorBag = error.data.errors;
                })
        },
        draw() {
            window.$('.btn-datatable-CategoriaViatico').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                this.showCategoriaViatico(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
            this.$router.push('/Login');
        } 
    }
};
